<template>
  <nav class="navigation navbar">
    <ul class="pull-left left-menu">
        <li><router-link to="/">{{ $t("xdata.Nav_gsjs") }}</router-link></li>
        <li>
            <span>{{ $t("xdata.Nav_cpfw") }}</span>
            <ul>
                <li><router-link to="/integration">{{ $t("xdata.Nav_xtjc") }}</router-link></li>
                <li><router-link to="/itsourcing">{{ $t("xdata.Nav_itwb") }}</router-link></li>
                <li><router-link to="/operation">{{ $t("xdata.Nav_qqwltx") }}</router-link></li>
                <li><router-link to="/dataCenter">{{ $t("xdata.Nav_idcsjzx") }}</router-link></li>
                <li><router-link to="/vpnSolution">{{ $t("xdata.Nav_vpnjjfa") }}</router-link></li>
            </ul>
        </li>
        <li><router-link to="/sdwan">SDWAN</router-link>
        </li>
        <li><router-link to="/about">{{ $t("xdata.Nav_lxwm") }}</router-link></li>
    </ul>
    <ul class="pull-right right-menu">
      <li>
          <span>{{lang | filtLang}}</span>
          <ul>
              <li><span @click="changeLangEvent('zh')">{{ $t("xdata.Nav_lang_zh") }}</span></li>
              <li><span @click="changeLangEvent('en')">{{ $t("xdata.Nav_lang_en") }}</span></li>
              <!-- <li><span @click="changeLangEvent('fr')">{{ $t("xdata.Nav_lang_fr") }}</span></li>
              <li><span @click="changeLangEvent('hu')">{{ $t("xdata.Nav_lang_xy") }}</span></li>
              <li><span @click="changeLangEvent('de')">{{ $t("xdata.Nav_lang_de") }}</span></li> -->
          </ul>
      </li>
      <!-- <li class="hk"><span>{{ $t("ict.Nav_xgwz") }}</span></li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      lang: localStorage.getItem("lang")
    };
  },
  created: function() {
  },
  filters: {
    filtLang(val){
      let text = ''
      console.log(val)
      switch(val) {
        case 'zh-CN' :
          text = '中文'
          break;
        case 'en-US':
          text = 'English'
          break;
        case 'hu-HU':
          text = 'Magyar'
          break;
        case 'de-DE':
          text = 'Deutsch'
          break;
        case 'fr-FR':
          text = 'Français'
          break;
        default:
      }
      return text
    }
  },
  methods: {
    changeLangEvent(val) {
      if (val == "en") {
        var lang = "en-US";
        localStorage.setItem('lang', lang);
      this.langType = false
      } else if (val == "zh"){
        var lang = "zh-CN";
        localStorage.setItem('lang', lang);
        this.langType = true 
      } else if (val == "hu"){
        var lang = "hu-HU";
        localStorage.setItem('lang', lang);
        this.langType = true 
      }else if (val == "fr"){
        var lang = "fr-FR";
        localStorage.setItem('lang', lang);
        this.langType = true 
      }else if (val == "de"){
        var lang = "de-DE";
        localStorage.setItem('lang', lang);
        this.langType = true 
      }
      location.reload();
    }
  }
};
</script>
<style scoped>
.navbar{height: 100px; width: 100%;display: flex;align-items: center;justify-content: space-between;}
.navbar-nav .language .activeL{
  color: #fff;
}
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.navigation{
  display: flex;
  background: rgba(0, 0, 0, 0.3);
}

.navigation ul {
  list-style-type: none;
  padding: 0;
  margin: 0 auto;
}

.navigation .left-menu li {
  display: inline-block;
  position: relative;
  transition: all 0.3s;
}
.navigation .right-menu li {
  display: inline-block;
  transition: all 0.3s;
  position: relative;
  min-width: 100px;
  width: 100%;
}

.navigation ul li span,
.navigation ul li a {
  display: block;
  padding: 8px 20px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  text-align: center;
}
.navigation ul li ul{
  display: none;
  position: absolute;
  background: #f9f9f9;
  animation: slideDown 0.3s forwards;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.navigation .left-menu li ul li{
  width: 100%;
  min-width: 180px;
  text-align: center;
}
.navigation ul li ul li span,
.navigation ul li ul li a{
  color: rgba(0, 0, 0, 0.8);
  transition: all 0.3s;
  font-size: 14px;
}
.navigation ul li:hover > span,
.navigation ul li:hover > a{
  color: #fff;
}
.navigation ul li ul li:hover{
  background: #009DE4;
}
.navigation ul li ul li:hover span,
.navigation ul li ul li:hover a{
  color: #fff;
}

.navigation ul li:hover ul {
  display: block;
}
.navigation ul .hk{
  border: 2px solid #fff;
  border-radius: 4px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue